import { Theme, createStyles } from '@material-ui/core/styles';

export const styles = (theme: Theme) => createStyles({
    gridContainer: {
        fontFamily: 'MuseoSans, sans-serif',
        margin: '0 0 150px 0',
        display: 'flex',
        flexDirection: 'row',
        '& #mcFisica': {
          width:'70%',
            '& img': {
              height: 'auto !important',
              width: '100% !important',
            },
        },
        [theme.breakpoints.down(1200)]: {
          '& #mcFisica': {
            width:'70%',
          },
        },
        [theme.breakpoints.down(905)]: {
          '& #mcFisica': {
            width:'63%',
          },
        },
        [theme.breakpoints.down(850)]: {
          margin: '0 0 110px 0',
        },
        [theme.breakpoints.down(701)]: {
          flexDirection: 'column',
          margin: '0 0 100px 0',
          '& #mcFisica': {
            width:'80%',
          },
        },
        [theme.breakpoints.down(400)]: {
          margin: '0 0 80px 0',
          '& #mcFisica': {
            width:'85%',
          },
        },
    },
    textContainer: {
        width: '24%',
        margin: '0% 5% 10% 9%',
        [theme.breakpoints.down(905)]: {
          margin: '0% 4% 10% 7%',
        },
        [theme.breakpoints.down(701)]: {
          alignSelf:'flex-end',
          margin: '7% 10% 10% 0%',
          width: '35%',
        },
        [theme.breakpoints.down(550)]: {
          width: '45%',
          margin: '7% 7% 10% 0%',
        },
        [theme.breakpoints.down(400)]: {
          width: '50%',
        },
    },
    subSectionIndex: {
        fontWeight: 900,
        fontSize: '18.31px',
        color: theme.palette.primary.section,
        flexDirection: 'column',
        marginBottom: '77.25px',
        letterSpacing: '1.71px',
        lineHeight: '29px',
        marginRight:'10%',
        [theme.breakpoints.down(1200)]: {
            marginBottom: '70px',
        },
        [theme.breakpoints.down(1001)]: {
            fontSize: '15.5px',
            lineHeight: '25px',
        },
        [theme.breakpoints.down(850)]: {
            marginBottom: '50px',
        },
        [theme.breakpoints.down(701)]: {
          marginBottom: '32px',
          fontSize: '15px',
          lineHeight: '22px',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '13px',
          marginBottom: '28px',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '12px',
          lineHeight: '20px',
        },
        [theme.breakpoints.down(400)]: {
          fontSize: '11px',
          lineHeight: '19px',
        },
        [theme.breakpoints.down(350)]: {
          lineHeight: '18px',
        },
    },
    text: {
        fontSize: '18.3px',
        color: '#3D4274',
        letterSpacing: '0.75px',
        lineHeight: '26.35px',
        fontWeight: 500,
        marginBottom:'20%',
        [theme.breakpoints.down(1001)]: {
            fontSize: '15.5px',
            lineHeight: '25px',
        },
        [theme.breakpoints.down(850)]: {
          marginBottom:'15%',
        },
        [theme.breakpoints.down(701)]: {
          fontSize: '15px',
          lineHeight: '22px',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '13px',
          lineHeight: '21px',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '12px',
          lineHeight: '20px',
        },
        [theme.breakpoints.down(400)]: {
          fontSize: '11px',
          lineHeight: '19px',
        },
        [theme.breakpoints.down(350)]: {
          lineHeight: '18px',
        },
    },
    specialText: {
      fontFamily: 'MuseoSans, sans-serif',
      fontWeight: 700,
      color: '#3D4274',
      fontSize: '19px',
      letterSpacing: '1.7px',
      lineHeight: '30px',
      marginRight:'20%',
      [theme.breakpoints.down(1001)]: {
          fontSize: '17.5px',
          lineHeight: '28px',
      },
      [theme.breakpoints.down(701)]: {
        fontSize: '17px',
        lineHeight: '25px',
      },
      [theme.breakpoints.down(550)]: {
        fontSize: '14.5px',
        lineHeight: '24px',
        marginBottom:'0',
      },
      [theme.breakpoints.down(450)]: {
        fontSize: '13px',
        lineHeight: '20px',
      },
      [theme.breakpoints.down(400)]: {
        fontSize: '12px',
        lineHeight: '18px',
      },
      [theme.breakpoints.down(350)]: {
        lineHeight: '17px',
      },
    },
    amountText: {
      fontFamily: 'MuseoSans, sans-serif',
      fontSize: '120px',
      color: '#3D4274',
      letterSpacing: '0.75px',
      fontWeight: 900,
      [theme.breakpoints.down(1001)]: {
          fontSize: '110px',
      },
      [theme.breakpoints.down(701)]: {
        fontSize: '100px',
      },
      [theme.breakpoints.down(550)]: {
        fontSize: '80px',
        marginBottom:'0',
        lineHeight: '115px',
      },
    },
});
